import { actionLog } from './actionlog.service';

export const MIN_MOTIVO_SAIDA = 20;
export const MAX_MOTIVO_SAIDA = 100;

export interface ResultadoSaida {
  ok: boolean;
  mensagem?: string;
}

/**
 * A recusa não vem como HTTP 4xx: medido na instância, uma trigger `before_win`
 * de action tem a exceção engolida pela plataforma — o action_log é criado do
 * mesmo jeito e a resposta volta 201. Por isso o veredito vive em
 * `attributes.status`, e a mensagem legível em `attributes.systemMessage`,
 * mesmo contrato que a tela de reconhecer já usa.
 */
export async function sairDoPrograma(motivo: string): Promise<ResultadoSaida> {
  const log = await actionLog('me', 'sair_do_programa', { motivo: motivo.trim() });
  const attributes = log?.action?.attributes;

  if (attributes?.status === 'OK') {
    return { ok: true, mensagem: attributes?.systemMessage };
  }

  return { ok: false, mensagem: attributes?.systemMessage };
}
